/** Idle time before the session lock screen appears. */
export const SESSION_IDLE_LOCK_MS = 10 * 60 * 1000;

/** Total idle time before the user is fully logged out. */
export const SESSION_IDLE_LOGOUT_MS = 60 * 60 * 1000;

/** How often idle state is re-evaluated. */
export const SESSION_IDLE_CHECK_INTERVAL_MS = 30 * 1000;

const formatIdleDuration = (ms) => {
	if (ms >= 60 * 1000) {
		const minutes = Math.round(ms / (60 * 1000));
		return `${minutes} minute${minutes === 1 ? '' : 's'}`;
	}
	const seconds = Math.round(ms / 1000);
	return `${seconds} second${seconds === 1 ? '' : 's'}`;
};

export const formatSessionCountdown = (ms) => {
	const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;
	const mm = String(minutes).padStart(2, '0');
	const ss = String(seconds).padStart(2, '0');
	if (hours > 0) {
		return `${hours}:${mm}:${ss}`;
	}
	return `${mm}:${ss}`;
};

/** User-facing copy explaining why the session lock screen appeared. */
export const getSessionLockMessage = () => {
	const lockAfter = formatIdleDuration(SESSION_IDLE_LOCK_MS);

	return `For your security, your session was locked after ${lockAfter} of inactivity. Enter your password to pick up where you left off.`;
};
